<template>
	<div class="page-content-wrapper">
		<div class="container-fluid">
			<div class="row">
				<evaluacioAlumno />
				<detallesEvaluacion />
			</div>
		</div>
		<toastComponent ref="toastComponent"/>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import evaluacioAlumno from "../components/curso/evaluacionesAlumno";
import detallesEvaluacion from '../components/curso/detallesEvaluacion';
import toastComponent from '../components/toastComponent'
export default {
	components: {
		evaluacioAlumno,
		detallesEvaluacion,
		toastComponent
	},
	data: () => ({}),
	methods: {
		...mapActions("menu", ["updateMenu"]),
		...mapActions("menu", ["updateTitulo"]),
		...mapActions('alumno',['updateJsonAlumno']),
		...mapActions('evaluacion',['updateEvaluacion']),
		...mapActions('curso',['updateOnlyCurso']),
		...mapActions('evaluacion',['updateActiveEvaluacion']),
		async getCurso(idCurso){

			const {data} = await this.axios.get("api/getCurso/" + idCurso);
			const {getCurso,ok,error} = data;
			if (!ok) {
        //Curso no corresponde a la coordinadora lo devuelve
        let arrayToast = {
          msg: `${error}. Redireccionando...`,
          title: "Error",
          variant: "danger"
        };
        this.$refs.toastComponent.makeToast(arrayToast);
        setTimeout(() => this.$router.push({ path: "/index" }), 5000);
        return false;
      }
			this.updateOnlyCurso(getCurso);
		},
		async getEvaluacion(idCurso) {

			this.updateActiveEvaluacion(true);

			const { data } = await this.axios.get(
				"api/getEvaluacioneAlumnos/" + idCurso
			);

			const {alumnoLista,evaluaciones} = data;
			const tablaAlumno = alumnoLista.map((al) => ({
				...al,
				promedioFinal: al.promedioFinal ? al.promedioFinal : "-",
				evaluacion: al.evaluacion.map(ev=>({...ev,nota: ev.notaAlumno ? ev.notaAlumno.nota : "-",})),
				estado: al.promedioFinal == null ? 2 : al.promedioFinal < 4 ? 0 : 1,
			}));

			this.updateJsonAlumno(tablaAlumno);
			this.updateEvaluacion(evaluaciones);
			this.updateActiveEvaluacion(false);
			//this.dataAlumno = tablaAlumno;
		},
	},
	created() {
		const titulo = "Panel Reinicio Evaluación";

		const menu = [
			{ urlTolbar: "index", nameToolbar: "Inicio" },
			{
				titulo: "Info - Curso",
				urlTolbar:
					"infoCurso/" +
					this.$route.params.idCurso,
				nameToolbar: "Info Curso",
			},
			{
				titulo: "Reinicio - Nota",
				urlTolbar:
					"reinicio-nota/" +
					this.$route.params.idCurso,
				nameToolbar: "Reinicio Nota",
			},
		];
		this.updateMenu(menu);
		this.updateTitulo(titulo);

		this.getCurso(this.$route.params.idCurso);
		this.getEvaluacion(this.$route.params.idCurso);
		
	},
};
</script>
